import constants from './line-item-constants'

export default {
  get: function (categs, showSavingsFields, isP2PInvoice, companySettings, currencyCode) {
    let isP2PInvoiceWithItems = isP2PInvoice && companySettings.AllowEditItem
    let displayRemainingQty = !(isP2PInvoice && companySettings.AllowInvoiceToExceedPOQty)
    showSavingsFields = showSavingsFields && !isP2PInvoiceWithItems
    let useSupplementalPrecision = companySettings.CurrenciesWithSupplementalPrecision.indexOf(currencyCode) !== -1

    return {
      '*name': {
        label: 'Product Name',
        width: showSavingsFields ? 150 : 200,
        editable: !isP2PInvoice
      },
      category: {
        label: 'Category',
        width: 100,
        source: true,
        options: categs,
        compose: categName,
        editable: !isP2PInvoice
      },
      poQuantity: isP2PInvoiceWithItems
        ? {
          label: 'PO Qty',
          width: 65,
          compose: poQuantityFormat,
          f: poQuantityFormat,
          editable: false,
          type: 'amount text-right'
        }
        : null,
      poUnits: isP2PInvoiceWithItems
        ? {
          label: 'PO Units',
          width: showSavingsFields ? 50 : 75,
          compose: poUnitsFormat,
          f: poUnitsFormat,
          editable: false,
          type: 'amount text-right'
        }
        : null,
      remainingQuantity: isP2PInvoiceWithItems && displayRemainingQty
        ? {
          label: 'Remaining Qty',
          width: showSavingsFields ? 50 : 100,
          compose: remainingQuantityFormat,
          f: remainingQuantityFormat,
          editable: false,
          type: 'amount text-right'
        }
        : null,
      quantity: {
        label: isP2PInvoiceWithItems ? 'Invoice Qty' : 'Quantity',
        width: showSavingsFields ? 70 : (isP2PInvoiceWithItems ? 90 : 80),
        compose: quantityFormat,
        f: quantityFormat,
        editable: !isP2PInvoice || isP2PInvoiceWithItems,
        notEditableIf: {
          f: 'isQuantityReadonly'
        },
        type: 'qty',
        maxThreshold: isP2PInvoiceWithItems ? {
          value: 0,
          f: 'maxQuantity'
        } : null,
        minThreshold: isP2PInvoiceWithItems ? {
          value: 0
        } : null,
        decimals: 2
      },
      units: {
        label: isP2PInvoiceWithItems ? 'Invoice Units' : 'Units',
        width: showSavingsFields ? 50 : (isP2PInvoiceWithItems ? 85 : 80),
        compose: unitsFormat,
        f: unitsFormat,
        editable: !isP2PInvoice || isP2PInvoiceWithItems,
        notEditableIf: {
          f: 'isUnitsReadonly'
        },
        type: 'qty',
        showDefaultEmpty: true,
        maxThreshold: isP2PInvoiceWithItems ? {
          value: 0,
          f: 'poUnits'
        } : null,
        minThreshold: isP2PInvoiceWithItems ? {
          value: 0
        } : null,
        decimals: 2
      },
      unitPriceSGR: showSavingsFields
        ? {
          label: 'SGR',
          width: 100,
          fixed: true,
          compose: sgrFormat,
          getter: sgrFormat,
          useSupplementalPrecision: useSupplementalPrecision,
          visible: showSavingsFields,
          editable: !isP2PInvoice
        }
        : null,
      unitPricePreferredRate: showSavingsFields
        ? {
          label: 'Preferred',
          width: 100,
          fixed: true,
          compose: preferredFormat,
          getter: preferredFormat,
          useSupplementalPrecision: useSupplementalPrecision,
          visible: showSavingsFields,
          editable: !isP2PInvoice
        }
        : null,
      unitPriceNegotiatedRate: showSavingsFields
        ? {
          label: 'Negotiated',
          width: 100,
          fixed: true,
          compose: negotiatedFormat,
          getter: negotiatedFormat,
          useSupplementalPrecision: useSupplementalPrecision,
          visible: showSavingsFields,
          editable: !isP2PInvoice
        }
        : null,
      unitPrice: {
        label: 'Price',
        width: 90,
        compose: priceFormat,
        getter: priceFormat,
        useSupplementalPrecision: useSupplementalPrecision,
        editable: !isP2PInvoice || isP2PInvoiceWithItems,
        maxThreshold: isP2PInvoiceWithItems ? {
          f: 'maxUnitPrice',
          value: 0
        } : null,
        minThreshold: isP2PInvoiceWithItems ? {
          value: -constants.maxAmount
        } : null
      },
      total: {
        label: 'Total Price',
        compose: totalFormat,
        f: totalFormat,
        validationCol: 'totalToValidate',
        width: isP2PInvoiceWithItems ? 135 : 140,
        fixed: true,
        editable: false,
        alias: isP2PInvoiceWithItems && companySettings.ExcludeTaxesFromPOThreshold
          ? 'Total Price without taxes'
          : null,
        maxThreshold: isP2PInvoiceWithItems && companySettings.AllowInvoiceToExceedPOQty ? {
          f: 'maxTotalAmount',
          value: 0
        } : null,
        minTotalThreshold: { f: 'minTotalAmount', value: 0 }
      },
      details: {
        label: '+',
        details: 'local'
      },
      $$actionable: p => !p.data.isAutoGenerated,
      maxUnitPrice: {
        label: 'Unit Price',
        editable: false,
        visible: false
      },
      maxQuantity: {
        label: 'Quantity',
        editable: false,
        visible: false
      }
    }
  }
}

function totalFormat(params) {
  return params.data.totalWithTaxesAndFees
}

function categName(params) {
  return params.data &&
    params.data.isFeeDiscountItem === false
      ? (params.value ? params.value.text : '')
      : ''
}

function sgrFormat(params) {
  if (params.data.isFeeDiscountItem === true) {
    params.data._disabled = true
    params.data.unitPriceSGR = ''
  }

  return params.data.unitPriceSGR
    ? parseFloat(params.data.unitPriceSGR)
    : null
}

function negotiatedFormat(params) {
  if (params.data.isFeeDiscountItem === true) {
    params.data._disabled = true
    params.data.unitPriceNegotiatedRate = ''
  }

  return params.data.unitPriceNegotiatedRate
    ? parseFloat(params.data.unitPriceNegotiatedRate)
    : null
}

function preferredFormat(params) {
  if (params.data.isFeeDiscountItem === true) {
    params.data._disabled = true
    params.data.unitPricePreferredRate = ''
  }

  return params.data.unitPricePreferredRate
    ? parseFloat(params.data.unitPricePreferredRate)
    : null
}

function priceFormat(params) {
  if (params.data.isFeeDiscountItem === true) {
    params.data._disabled = true
    params.data.unitPrice = params.data.total
  }

  if (params.data.remainingQuantity && params.data.remainingQuantity === 0) {
    params.data.unitPrice = 0
    return null
  }

  return params.data.unitPrice
    ? parseFloat(params.data.unitPrice)
    : null
}

function unitsFormat(params) {
  if (params.data.hideQtyWhenZero && Number(params.data.units) === 0) return null
  return params.data &&
    params.data.isFeeDiscountItem === true
      ? ''
      : params.data.units && Number(params.data.units) !== 0
        ? parseFloat(params.data.units)
        : null
}

function quantityFormat(params) {
  if (params.data.hideQtyWhenZero && Number(params.data.quantity) === 0) return null
  return params.data.quantity || params.data.quantity === 0
    ? parseFloat(params.data.quantity)
    : (params.data.remainingQuantity === 0 ? 0 : null)
}

function poQuantityFormat(params) {
  return params.data.poQuantity
    ? parseFloat(params.data.poQuantity)
    : null
}

function poUnitsFormat(params) {
  return params.data &&
    params.data.isFeeDiscountItem === true
      ? ''
      : params.data.poUnits
        ? parseFloat(params.data.poUnits)
        : null
}

function remainingQuantityFormat(params) {
  return params.data &&
    params.data.isFeeDiscountItem === true
      ? ''
      : params.data.remainingQuantity || params.data.remainingQuantity === 0
        ? parseFloat(params.data.remainingQuantity)
        : null
}



// WEBPACK FOOTER //
// ./src/components/_modules/I2P/models/line-item.js